import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnPK: CultureInfo = {
  name: 'en-PK',
  displayName: 'English (Pakistan)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-PK',
  parent: CultureInfoEn
};
